import type { ApiKey } from '@nucleus-commerce/api-client/admin';

import type { DocsKey } from '../../schemas/docs-storage-schema';

/** `unknown` until the store's key list has loaded, or when the member may not read it. */
export type KeyStatus = 'active' | 'revoked' | 'missing' | 'unknown';

/**
 * Reconciles the keys this browser holds with the store's list (plan 9.1): the list carries only
 * the 12-character prefix, so a stored key whose prefix is gone was deleted (or belongs to another
 * store), and one with `revokedAt` was revoked. Either way the API will refuse it.
 */
export function keyStatus(key: DocsKey, storeKeys: readonly ApiKey[] | undefined): KeyStatus {
  if (!storeKeys) return 'unknown';
  const match = storeKeys.find((k) => k.prefix === key.prefix);
  if (!match) return 'missing';
  return match.revokedAt ? 'revoked' : 'active';
}
